import React, { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';
// import './Bonafide.css';
import ID from "../../assets/images/Id.jpeg";
import ID2 from "../../assets/images/ID2.jpeg";
import ID3 from "../../assets/images/ID3.jpg";
import ID4 from "../../assets/images/ID4.png";
import ID5 from "../../assets/images/ID5.png";
import ID6 from "../../assets/images/ID6.png";
import ID7 from "../../assets/images/ID7.png";
import ID8 from "../../assets/images/ID8.png";


function TIdDoc({ submitted, formData, selectedTeachers, logoData }) {
  const [schoolData, setSchoolData] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false)
  const [logoURL, setLogoURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [udiseNumber, setUdiseNumber] = useState('');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [design, setDesign] = useState('default');

  const language = localStorage.getItem('language') || 'English';


  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);
  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      fetchSchoolData(schoolUdiseNumber);
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    handleResize(); // Check initial screen size
    window.addEventListener("resize", handleResize); // Add event listener for window resize
    return () => window.removeEventListener("resize", handleResize); // Clean up event listener
  }, []);

  const fetchSchoolData = async (udiseNumber) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      // console.log("School data:", data);
      setSchoolData(data);
      if (data && data.schoolLogo) {
        const storageRef = firebase.storage().refFromURL(data.schoolLogo);
        const url = await storageRef.getDownloadURL();
        console.log("Logo URL:", url);
        setLogoURL(url);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching school data:", error);
      setLoading(false);
    }
  };





  const renderIDCard = (teacher) => {
    if (!schoolData || !teacher) return null;

    

    return (
      <div>
        {design === 'default' && (
          <div
            style={{
              backgroundImage: `url(${ID3})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative',
              width: '4.4in',
              height: '2.74in',
              margin: '10px',
              border: '1px solid black',
              boxSizing: 'border-box',
              fontFamily: "'NotoSansDevanagari', sans-serif",
            }}
          >
       
            <p style={{ position: 'absolute', bottom: '1.4in', right: '1.7in', fontSize: '16.5px', color: 'white' }}>
              <b>{language === "English" ? "IDENTITY CARD" : "ओळखपत्र"}</b>
            </p>

            <div style={{ position: 'absolute', top: '1.18in', left: '1.42in', textAlign: 'left', color: 'black', fontSize: '15px', lineHeight: '1.3' }}>
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Name :" : "नाव :"} {teacher.Name}</b>
              </p>
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Mobile :" : "मोबाइल :"} {teacher.Mobno || ''}</b>
              </p>
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Birth Date :" : "जन्मतारीख :"} {teacher.DOB || ' '}</b>
              </p>
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Date of Joining :" : "सेवा रुजू तारीख :"} {teacher.DOJ || ''}</b>
              </p>
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Qualification :" : "शैक्षणिक पात्रता :"} {teacher.Qualification || ''}</b>
              </p>
              {/* Conditionally render the Subject field */}
              {teacher.subject ? (
                <p style={{ margin: '3.5px 0' }}>
                  <b>{language === "English" ? "Subject :" : "विषय :"} {teacher.subject}</b>
                </p>
              ) : <p> </p>}


              <p style={{ position: "absolute",
              top: "1.233in",
              left: "-1.39in", fontSize: '16.5px', color: 'Black' }}>
                <b> {teacher.Designation || ''}</b>
              </p>
            </div>
           
            <div>
          <div
            style={{
              position: "absolute",
              top: "0.20in",
              left: "0.08in",
            }}
          >
            {logoURL && (
              <img
                src={logoURL}
                alt="School Logo"
                style={{ width: "38px", height: "38px" }}
              />
            )}
          </div>
          <div style={{width:'84%',  fontSize: '16px', fontWeight: 'bold', color: 'white',  position: 'absolute', top: '0.2in', right: '0.1in', lineHeight: '1.2'  }}>
            {schoolData?.schoolName}
          </div>
        
        </div>
            <div style={{ position: 'absolute', top: '0.81in', right: '3.03in' }}>
              {teacher.Image && (
                <img
                  src={teacher.Image}
                  alt="Teacher Photo"
                  style={{
                    width: '1.2in',
                    height: '1.2in',
                    borderRadius: '50%',
                    border: '1px solid #297391',
                  }}
                />
              )}
            </div>
            <div style={{ position: 'absolute', bottom: '0.35in', right: '0.4in' }}>
              {schoolData?.signature && (
                <img
                  src={schoolData.signature}
                  alt="Principal Signature"
                  style={{
                    width: '0.8in',
                    height: 'auto',
                  }}
                />
              )}
            </div>
            <div style={{ position: 'absolute', bottom: '0.2in', right: '0.5in', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>
              {language === "English" ? "PRINCIPAL" : "प्राचार्य"}
            </div>
          </div>
        )}
        {design === 'ID5' && (
          <div
            style={{
              backgroundImage: `url(${ID5})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative',
              width: '4.4in',
              height: '2.74in',
              margin: '10px',
              border: '1px solid black',
              boxSizing: 'border-box',
              fontFamily: "'NotoSansDevanagari', sans-serif",
            }}
          >
       
            <p style={{ position: 'absolute', bottom: '1.54in', left: '1.55in', fontSize: '19.5px', color: 'Black' }}>
              <b>{teacher.Name || ' '}</b>
            </p>
            <p style={{ position: 'absolute', bottom: '1.33in', left: '1.9in', fontSize: '17px', color: 'rgb(82, 67, 67)' }}>
              <b>{teacher.Designation || ''}</b>
            </p>

            <div style={{ position: 'absolute', top: '1.34in', left: '1.55in', textAlign: 'left', color: 'black', fontSize: '14.5px', lineHeight: '1.3' }}>
              
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Mobile :" : "मोबाइल :"} {teacher.Mobno || ''}</b>
              </p>
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Birth Date :" : "जन्मतारीख :"} {teacher.DOB || ' '}</b>
              </p>
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Date of Joining :" : "सेवा रुजू तारीख :"} {teacher.DOJ || ''}</b>
              </p>
              <p style={{ margin: '3.5px 0' }}>
                <b>{language === "English" ? "Qualification :" : "शैक्षणिक पात्रता :"} {teacher.Qualification || ''}</b>
              </p>
              {/* Conditionally render the Subject field */}
              {teacher.subject ? (
                <p style={{ margin: '3.5px 0' }}>
                  <b>{language === "English" ? "Subject :" : "विषय :"} {teacher.subject}</b>
                </p>
              ) : <p> </p>}


            
            </div>
           
            <div>
          <div
            style={{
              position: "absolute",
              top: "0.38in",
              right: "0.06in",
            }}
          >
            {logoURL && (
              <img
                src={logoURL}
                alt="School Logo"
                style={{ width: "38px", height: "38px" }}
              />
            )}
          </div>
          <div style={{width:'89%',  fontSize: '16px', fontWeight: 'bold', color: 'rgb(53, 44, 44)',  position: 'absolute', top: '0.45in', left:'0.1in', lineHeight: '1.2'  }}>
            {schoolData?.schoolName}
          </div>
        
        </div>
            <div style={{ position: 'absolute', top: '0.82in', right: '3in' }}>
              {teacher.Image && (
                <img
                  src={teacher.Image}
                  alt="Teacher Photo"
                  style={{
                    width: '1.23in',
                    height: '1.4in',
                    border:'2px solid rgb(131, 117, 117)'
                  }}
                />
              )}
            </div>
            <div style={{ position: 'absolute', bottom: '0.45in', right: '0.05in' }}>
              {schoolData?.signature && (
                <img
                  src={schoolData.signature}
                  alt="Principal Signature"
                  style={{
                    width: '0.8in',
                    height: 'auto',
                  }}
                />
              )}
            </div>
            <div style={{ position: 'absolute', bottom: '0.28in', right: '0.1in', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>
              {language === "English" ? "PRINCIPAL" : "प्राचार्य"}
            </div>
          </div>
        )}
        
        {/* Add similar logic for 'new' and 'alternative' designs */}
        {design === 'new' && (


          <div
            style={{
              backgroundImage: ` url(${ID})`, // Add the image to the background
              backgroundSize: 'cover', // Cover the entire background with the image
              backgroundPosition: 'center', // Center the image
              transform: 'rotate(0deg)', // Rotate the image 180 degrees
              left: '2px',
              top: '20px',
              position: 'relative',
              width: '4.64in',  // increased by 10% (4in * 1.1)
              height: '2.87in',  // increased by 10% (2.6in * 1.1)
              margin: '10px',
              border: '1px solid black',
              boxSizing: 'border-box',
              padding: '0.0in',
              fontFamily: "'NotoSansDevanagari', sans-serif",
              // Responsive adjustments
              '@media (max-width: 1200px)': {  // For screens narrower than 1200px
                right: '0in',
                width: '8in',
                height: '11in',
              },
              '@media (max-width: 992px)': {  // For screens narrower than 992px
                right: '0in',
                width: '8.5in',
                height: '11.5in',
              },
              '@media (max-width: 768px)': {  // For screens narrower than 768px
                top: '0.2in',
                right: '0in',
                width: '100%',
                height: 'auto',
                padding: '0.1in',
              },
            }}
          >

            <div
              style={{
                transform: 'rotate(-90deg)',
                width: '2.3in',  // Set the width to the height of the box
                height: '100%',  // Set the height to 100% to fill the available space
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'left',
                textAlign: 'center',
                position: 'absolute',
                left: '22px',
                top: 0,
              }}
            >
              <div
            style={{
              position: "absolute",
              top: "0.16in",
              left: "-0.21in",
            }}
          >
            {logoURL && (
              <img
                src={logoURL}
                alt=" "
                style={{ width: "38px", height: "38px" }}
              />
            )}
          </div>
          <div style={{width:'88%',  fontSize: '17px', fontWeight: 'bold', color: 'white',  position: 'absolute', top: '0.1in', right: '0in', lineHeight: '1.3'  }}>
            {schoolData?.schoolName}
          </div>
        


            </div>
            <p style={{ transform: 'rotate(-90deg)', position: 'absolute', bottom: '1.1in', right: '3.28in', fontSize: '18px', color: 'white' }}><b>{language === "English" ? "IDENTITY CARD" : "ओळखपत्र"}</b></p>

            <div style={{ transform: 'rotate(-90deg)', position: 'absolute',  bottom: '0.69in', left: '2in',  color: 'black', fontSize: '15.5px', lineHeight: '1.5' }}>
              <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Name :" : "नाव :"} {teacher.Name}</b></p>
              <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Mobile :" : "मोबाइल :"} {teacher.Mobno}</b></p>
              <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Birth Date :" : "जन्मतारीख :"} {teacher.DOB}</b></p>
              <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Date of Joining :" : "सेवा रुजू तारीख :"} {teacher.DOJ}</b></p>
              <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Qualification :" : "शैक्षणिक पात्रता :"} {teacher.Qualification}</b></p>
              <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Designation :" : "पद :"} {teacher.Designation}</b></p>
              {/* Conditionally render the Subject field */}
              {teacher.subject && (
                <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Subject :" : "विषय :"} {teacher.subject}</b></p>
              )}
            </div>
            <div style={{ transform: 'rotate(-90deg)', }} >
              <div style={{ position: 'absolute', bottom: '-1.8in', right: '2.35in' }}>
                {schoolData?.signature && (
                  <img
                    src={schoolData.signature}
                    alt="Principal Signature"
                    style={{
                      width: '1in',
                      height: 'auto',
                    }}
                  />
                )}
              </div>
              <p style={{ position: 'absolute', bottom: '-2.1in', right: '2.4in', fontSize: '13px', color: 'black' }}> {language === "English" ? "PRINCIPAL " : "प्राचार्य "}</p>
              {/* <p style={{ position: 'absolute', top: '-0.9in', right: '2.2in' ,  fontSize: '8px', color: 'black' }}>Reg : {student.registerNo}</p> */}
            </div>



            <div style={{ position: 'absolute', top: '0.80in', right: '2.55in' }}>
              {teacher.Image && (
                <img
                  src={teacher.Image}
                  alt="Teacher Photo"
                  style={{
                    width: '1.2in',
                    height: '1.3in',
                    borderRadius: '50%', // Makes the image round
                    border: '4px solid lightgray', // Adds a light gray border with a thickness of 2px
                    transform: 'rotate(-90deg)', // Rotates the image 90 degrees
                  }}
                />
              )}
            </div>
          </div>
        )}

        {design === 'alternative' && (
          <div
            style={{
              backgroundImage: `url(${ID2})`, // Add the image to the background
              backgroundSize: 'cover', // Cover the entire background with the image
              backgroundPosition: 'center', // Center the image
              transform: 'rotate(0deg)', // Rotate the image 180 degrees
              left: '2px',
              top: '20px',
              position: 'relative',
              width: '4.4in',  // increased by 10% (4in * 1.1)
              height: '2.74in',  // increased by 10% (2.6in * 1.1)
              margin: '10px',
              border: '1px solid black',
              boxSizing: 'border-box',
              padding: '0.0in',
              fontFamily: "'NotoSansDevanagari', sans-serif",
            }}
          >

            <div
              style={{
                transform: 'rotate(-90deg)',
                width: '2.3in',  // Set the width to the height of the box
                height: '100%',  // Set the height to 100% to fill the available space
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'left',
                textAlign: 'center',
                position: 'absolute',
                left: '26px',
                top: 0,
              }}
            >
              <div
            style={{
              position: "absolute",
              top: "0.08in",
              left: "-0.16in",
            }}
          >
            {logoURL && (
              <img
                src={logoURL}
                alt="School Logo"
                style={{ width: "38px", height: "38px" }}
              />
            )}
          </div>
          <div style={{width:'86%',  fontSize: '15.5px', fontWeight: 'bold', color: 'white',  position: 'absolute', top: '0.05in', right: '0in', lineHeight: '1.3'  }}>
            {schoolData?.schoolName}
          </div>
            </div>



            {/* <div style={{ transform: 'rotate(-90deg)', fontSize: '13px', color: 'black', marginTop: '-11px', lineHeight: '0.15', marginLeft: '112px', width: '100%' }}> */}

            <div style={{ transform: 'rotate(-90deg)', position: 'absolute', top: '0.49in', left: '1.9in', textAlign: 'left', color: 'black', fontSize: '14px', whiteSpace: 'nowrap', lineHeight: '1.5' }}>
              <p style={{ margin: '4px 0', width: '3in', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Name :" : "नाव :"} {teacher.Name}</b></p>
              <p style={{ margin: '4px 0', width: '3in', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Mobile :" : "मोबाइल :"} {teacher.Mobno}</b></p>
              <p style={{ margin: '4px 0', width: '3in', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Birth Date :" : "जन्मतारीख :"} {teacher.DOB}</b></p>
              <p style={{ margin: '4px 0', width: '3in', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Date of Joining :" : "सेवा रुजू तारीख :"} {teacher.DOJ}</b></p>
              <p style={{ margin: '4px 0', width: '3in', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Qualification :" : "शैक्षणिक पात्रता :"} {teacher.Qualification}</b></p>
              <p style={{ margin: '4px 0', width: '3in', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Designation :" : "पद :"} {teacher.Designation}</b></p>
              {/* Conditionally render the Subject field */}
              {teacher.subject && (
                <p style={{ margin: '4px 0', width: '3in', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Subject :" : "विषय :"} {teacher.subject}</b></p>
              )}
            </div>
            <div style={{ transform: 'rotate(-90deg)', }} >
              <div style={{ position: 'absolute', bottom: '-1.9in', right: '2.35in' }}>
                {schoolData?.signature && (
                  <img
                    src={schoolData.signature}
                    alt="Principal Signature"
                    style={{
                      width: '1in',
                      height: 'auto',
                    }}
                  />
                )}
              </div>
              <p style={{ position: 'absolute', bottom: '-2.2in', right: '2.4in', fontSize: '13px', color: 'black' }}> {language === "English" ? "PRINCIPAL " : "प्राचार्य "}</p>
              <p style={{ position: 'absolute', bottom: '-0.60in', right: '3.1in', fontSize: '13px', color: 'black' }}> <b>{language === "English" ? "IDENTITY CARD " : "ओळखपत्र "}</b></p>

              {/* <p style={{ position: 'absolute', top: '-0.9in', right: '2.2in' ,  fontSize: '8px', color: 'black' }}>Reg : {student.registerNo}</p> */}
            </div>



            <div style={{ position: 'absolute', top: '0.72in', right: '2.33in' }}>
              {teacher.Image && (
                <img
                  src={teacher.Image}
                  alt="Teacher Photo"
                  style={{
                    width: '1.2in',
                    height: '1.3in',
                    borderRadius: '50%', // Makes the image round
                    border: '4px solid lightgray', // Adds a light gray border with a thickness of 2px
                    transform: 'rotate(-90deg)', // Rotates the image 90 degrees
                  }}
                />
              )}
            </div>
          </div>
        )}

        {design === 'new4' && (


<div
  style={{
    backgroundImage: ` url(${ID4})`, // Add the image to the background
    backgroundSize: 'cover', // Cover the entire background with the image
    backgroundPosition: 'center', // Center the image
    transform: 'rotate(0deg)', // Rotate the image 180 degrees
    left: '2px',
    top: '20px',
    position: 'relative',
    width: '4.64in',  // increased by 10% (4in * 1.1)
    height: '2.87in',  // increased by 10% (2.6in * 1.1)
    margin: '10px',
    border: '1px solid black',
    boxSizing: 'border-box',
    padding: '0.0in',
    fontFamily: "'NotoSansDevanagari', sans-serif",
    // Responsive adjustments
    '@media (max-width: 1200px)': {  // For screens narrower than 1200px
      right: '0in',
      width: '8in',
      height: '11in',
    },
    '@media (max-width: 992px)': {  // For screens narrower than 992px
      right: '0in',
      width: '8.5in',
      height: '11.5in',
    },
    '@media (max-width: 768px)': {  // For screens narrower than 768px
      top: '0.2in',
      right: '0in',
      width: '100%',
      height: 'auto',
      padding: '0.1in',
    },
  }}
>

  <div
    style={{
      transform: 'rotate(-90deg)',
      width: '2.3in',  // Set the width to the height of the box
      height: '100%',  // Set the height to 100% to fill the available space
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'left',
      textAlign: 'center',
      position: 'absolute',
      left: '22px',
      top: 0,
    }}
  >
    <div
  style={{
    position: "absolute",
    top: "0.14in",
    left: "-0.21in",
  }}
>
  {logoURL && (
    <img
      src={logoURL}
      alt=" "
      style={{ width: "38px", height: "38px" }}
    />
  )}
</div>
<div style={{width:'90%',  fontSize: '16px', fontWeight: 'bold', color: 'white',  position: 'absolute', top: '0.1in', right: '0in', lineHeight: '1.3'  }}>
  {schoolData?.schoolName}
</div>

<div style={{  fontSize: '18px', fontWeight: 'bold', color: 'Black',  position: 'absolute', top: '2.2in', left: '0.55in'  }}>
{teacher.Designation}
</div>

  </div>
  <p style={{ transform: 'rotate(-90deg)', position: 'absolute', bottom: '1.14in', left: '-0.1in', fontSize: '18px', color: 'white' }}><b>{language === "English" ? "IDENTITY CARD" : "ओळखपत्र"}</b></p>

  <div style={{ transform: 'rotate(-90deg)', position: 'absolute',  bottom: '0.72in', left: '2.1in',  color: 'black', fontSize: '14px', lineHeight: '1.5' }}>
    <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Name :" : "नाव :"} {teacher.Name}</b></p>
    <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Mobile :" : "मोबाइल :"} {teacher.Mobno}</b></p>
    <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Birth Date :" : "जन्मतारीख :"} {teacher.DOB}</b></p>
    <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Date of Joining :" : "सेवा रुजू तारीख :"} {teacher.DOJ}</b></p>
    <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Qualification :" : "शैक्षणिक पात्रता :"} {teacher.Qualification}</b></p>
    {/* <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Designation :" : "पद :"} {teacher.Designation}</b></p> */}
    {/* Conditionally render the Subject field */}
    {teacher.subject ? (
      <p style={{ margin: '4px 0' }}><b>{language === "English" ? "Subject :" : "विषय :"} {teacher.subject}</b></p>
    ): <p> </p>}
  </div>
  <div style={{ transform: 'rotate(-90deg)', }} >
    <div style={{ position: 'absolute', bottom: '-1.8in', right: '2.35in' }}>
      {schoolData?.signature && (
        <img
          src={schoolData.signature}
          alt="Principal Signature"
          style={{
            width: '1in',
            height: 'auto',
          }}
        />
      )}
    </div>
    <p style={{ position: 'absolute', bottom: '-2.1in', right: '2.4in', fontSize: '13px', color: 'black' }}> {language === "English" ? "PRINCIPAL " : "प्राचार्य "}</p>
    {/* <p style={{ position: 'absolute', top: '-0.9in', right: '2.2in' ,  fontSize: '8px', color: 'black' }}>Reg : {student.registerNo}</p> */}
  </div>



  <div style={{ position: 'absolute', top: '0.72in', right: '2.6in' }}>
    {teacher.Image && (
      <img
        src={teacher.Image}
        alt="Teacher Photo"
        style={{
          width: '1.4in',
          height: '1.4in',
          borderRadius: '50%', // Makes the image round
          border: '4px solid lightgray', // Adds a light gray border with a thickness of 2px
          transform: 'rotate(-90deg)', // Rotates the image 90 degrees
        }}
      />
    )}
  </div>
</div>
)}


{design === 'ID6' && (


<div
  style={{
    backgroundImage: ` url(${ID6})`, // Add the image to the background
    backgroundSize: 'cover', // Cover the entire background with the image
    backgroundPosition: 'center', // Center the image
    transform: 'rotate(0deg)', // Rotate the image 180 degrees
    left: '2px',
    top: '20px',
    position: 'relative',
    width: '4.64in',  // increased by 10% (4in * 1.1)
    height: '2.87in',  // increased by 10% (2.6in * 1.1)
    margin: '10px',
    border: '1px solid black',
    boxSizing: 'border-box',
    padding: '0.0in',
    fontFamily: "'NotoSansDevanagari', sans-serif",
    // Responsive adjustments
    '@media (max-width: 1200px)': {  // For screens narrower than 1200px
      right: '0in',
      width: '8in',
      height: '11in',
    },
    '@media (max-width: 992px)': {  // For screens narrower than 992px
      right: '0in',
      width: '8.5in',
      height: '11.5in',
    },
    '@media (max-width: 768px)': {  // For screens narrower than 768px
      top: '0.2in',
      right: '0in',
      width: '100%',
      height: 'auto',
      padding: '0.1in',
    },
  }}
>

  <div
    style={{
      transform: 'rotate(-90deg)',
      width: '2.3in',  // Set the width to the height of the box
      height: '100%',  // Set the height to 100% to fill the available space
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'left',
      textAlign: 'center',
      position: 'absolute',
      left: '22px',
      top: 0,
    }}
  >
    <div
  style={{
    position: "absolute",
    top: "0.4in",
    left: "-0.23in",
  }}
>
  {logoURL && (
    <img
      src={logoURL}
      alt=" "
      style={{ width: "38px", height: "38px" }}
    />
  )}
</div>


      <div
  style={{
    width: '90%',
    fontSize: '17px',
    fontWeight: 'bold',
    color: '#121d47',
    position: 'absolute',
    top: '0.47in',
    right: '0in',
    lineHeight: '1.3em',
    overflow: 'visible',  // ✅ Allow it to grow
    whiteSpace: 'normal', // ✅ Allow wrapping
    wordWrap: 'break-word' // Optional: breaks long words if needed
  }}
>
  {schoolData?.schoolName}
</div>

  </div>
 

  <div
  style={{
    transform: 'rotate(-90deg)',
    position: 'absolute',
    bottom: '0.63in',
    left: '1.85in',
    color: 'black',
    fontSize: '15px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center name and designation horizontally
    justifyContent: 'center',
    lineHeight: '1.3'
  }}
>
  {/* Centered Name */}
  <p style={{ margin: '1px 0', fontWeight: '600', color:'rgb(20, 31, 73)', fontSize:'17.5px' }}>
    <b>{teacher.Name}</b>
  </p>

  {/* Centered Designation */}
  <p style={{ margin: '1px 0', fontWeight: '500', color:'rgb(34, 46, 94)' , fontSize:'15.5px', marginBottom:'13px'}}>
    <b>{teacher.Designation}</b>
  </p>

  {/* Start from left */}
  <div style={{ alignSelf: 'flex-start', color:'rgb(37, 47, 88)' }}>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Mobile :' : 'मोबाइल :'} {teacher.Mobno}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Birth Date :' : 'जन्मतारीख :'} {teacher.DOB}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Date of Joining :' : 'सेवा रुजू तारीख :'} {teacher.DOJ}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Qualification :' : 'शैक्षणिक पात्रता :'} {teacher.Qualification}</b>
    </p>

    {/* Conditionally render the Subject field */}
    {teacher.subject && (
      <p style={{ margin: '3.5px 0' }}>
        <b>{language === 'English' ? 'Subject :' : 'विषय :'} {teacher.subject}</b>
      </p>
    )}
  </div>
</div>


  <div style={{ transform: 'rotate(-90deg)', }} >
    <div style={{ position: 'absolute', bottom: '-1.8in', right: '2.35in' }}>
      {schoolData?.signature && (
        <img
          src={schoolData.signature}
          alt="Principal Signature"
          style={{
            width: '1in',
            height: 'auto',
          }}
        />
      )}
    </div>
    <p style={{ position: 'absolute', bottom: '-2.1in', right: '2.4in', fontSize: '12px', color:'rgb(37, 47, 88)' }}> {language === "English" ? "PRINCIPAL " : "प्राचार्य "}</p>
    {/* <p style={{ position: 'absolute', top: '-0.9in', right: '2.2in' ,  fontSize: '8px', color: 'black' }}>Reg : {student.registerNo}</p> */}
  </div>



  <div style={{ position: 'absolute', top: '0.80in', right: '2.55in' }}>
    {teacher.Image && (
      <img
        src={teacher.Image}
        alt="Teacher Photo"
        style={{
          width: '1.2in',
          height: '1.3in',
          border: '3px solid rgb(29, 39, 78)', // Adds a light gray border with a thickness of 2px
          transform: 'rotate(-90deg)', // Rotates the image 90 degrees
        }}
      />
    )}
  </div>
</div>
)}
{design === 'ID7' && (


<div
  style={{
    backgroundImage: ` url(${ID7})`, // Add the image to the background
    backgroundSize: 'cover', // Cover the entire background with the image
    backgroundPosition: 'center', // Center the image
    transform: 'rotate(0deg)', // Rotate the image 180 degrees
    left: '2px',
    top: '20px',
    position: 'relative',
    width: '4.64in',  // increased by 10% (4in * 1.1)
    height: '2.87in',  // increased by 10% (2.6in * 1.1)
    margin: '10px',
    border: '1px solid black',
    boxSizing: 'border-box',
    padding: '0.0in',
    fontFamily: "'NotoSansDevanagari', sans-serif",
    // Responsive adjustments
    '@media (max-width: 1200px)': {  // For screens narrower than 1200px
      right: '0in',
      width: '8in',
      height: '11in',
    },
    '@media (max-width: 992px)': {  // For screens narrower than 992px
      right: '0in',
      width: '8.5in',
      height: '11.5in',
    },
    '@media (max-width: 768px)': {  // For screens narrower than 768px
      top: '0.2in',
      right: '0in',
      width: '100%',
      height: 'auto',
      padding: '0.1in',
    },
  }}
>

  <div
    style={{
      transform: 'rotate(-90deg)',
      width: '2.3in',  // Set the width to the height of the box
      height: '100%',  // Set the height to 100% to fill the available space
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'left',
      textAlign: 'center',
      position: 'absolute',
      left: '22px',
      top: 0,
    }}
  >
    <div
  style={{
    position: "absolute",
    top: "0.4in",
    left: "-0.23in",
  }}
>
  {logoURL && (
    <img
      src={logoURL}
      alt=" "
      style={{ width: "38px", height: "38px" }}
    />
  )}
</div>
<div
  style={{
    width: '90%',
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'rgb(4, 16, 59)',
    position: 'absolute',
    top: '0.47in',
    right: '0in',
    lineHeight: '1.2em',
    overflow: 'visible',  // ✅ Allow it to grow
    whiteSpace: 'normal', // ✅ Allow wrapping
    wordWrap: 'break-word' // Optional: breaks long words if needed
  }}
>
  {schoolData?.schoolName}
</div>
  </div>
 

  <div
  style={{
    transform: 'rotate(-90deg)',
    position: 'absolute',
    bottom: '0.6in',
    left: '2.2in',
    color: 'black',
    fontSize: '15px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center name and designation horizontally
    justifyContent: 'center',
    lineHeight: '1.3'
  }}
>
  {/* Centered Name */}
  <p style={{ margin: '1px 0', fontWeight: '600', color:'rgb(20, 31, 73)', fontSize:'17.5px' }}>
    <b>{teacher.Name}</b>
  </p>

  {/* Centered Designation */}
  <p style={{ margin: '1px 0', fontWeight: '500', color:'rgb(34, 46, 94)' , fontSize:'15.5px', marginBottom:'13px'}}>
    <b>{teacher.Designation}</b>
  </p>

  {/* Start from left */}
  <div style={{ alignSelf: 'flex-start', color:'rgb(37, 47, 88)' }}>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Mobile :' : 'मोबाइल :'} {teacher.Mobno}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Birth Date :' : 'जन्मतारीख :'} {teacher.DOB}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Date of Joining :' : 'सेवा रुजू तारीख :'} {teacher.DOJ}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Qualification :' : 'शैक्षणिक पात्रता :'} {teacher.Qualification}</b>
    </p>

    {/* Conditionally render the Subject field */}
    {teacher.subject && (
      <p style={{ margin: '3.5px 0' }}>
        <b>{language === 'English' ? 'Subject :' : 'विषय :'} {teacher.subject}</b>
      </p>
    )}
  </div>
</div>


  <div style={{ transform: 'rotate(-90deg)', }} >

    <p style={{ position: 'absolute', bottom: '-2.16in', right: '2.35in', fontSize: '12px', color:'rgb(0, 0, 0)' }}> {language === "English" ? "PRINCIPAL " : "प्राचार्य "}</p>
 
  </div>



  <div style={{ position: 'absolute', top: '0.80in', right: '2.4in' }}>
    {teacher.Image && ( 
      <img
        src={teacher.Image}
        alt="Teacher Photo"
        style={{
          width: '1.2in',
          height: '1.3in',
          border: '3px solid rgb(29, 39, 78)',
          borderRadius:'50%', // Adds a light gray border with a thickness of 2px
          transform: 'rotate(-90deg)', // Rotates the image 90 degrees
        }}
      />
    )}
  </div>
</div>
)}

{design === 'ID8' && (


<div
  style={{
    backgroundImage: ` url(${ID8})`, // Add the image to the background
    backgroundSize: 'cover', // Cover the entire background with the image
    backgroundPosition: 'center', // Center the image
    transform: 'rotate(0deg)', // Rotate the image 180 degrees
    left: '2px',
    top: '20px',
    position: 'relative',
    width: '4.64in',  // increased by 10% (4in * 1.1)
    height: '2.87in',  // increased by 10% (2.6in * 1.1)
    margin: '10px',
    border: '1px solid black',
    boxSizing: 'border-box',
    padding: '0.0in',
    fontFamily: "'NotoSansDevanagari', sans-serif",
    // Responsive adjustments
    '@media (max-width: 1200px)': {  // For screens narrower than 1200px
      right: '0in',
      width: '8in',
      height: '11in',
    },
    '@media (max-width: 992px)': {  // For screens narrower than 992px
      right: '0in',
      width: '8.5in',
      height: '11.5in',
    },
    '@media (max-width: 768px)': {  // For screens narrower than 768px
      top: '0.2in',
      right: '0in',
      width: '100%',
      height: 'auto',
      padding: '0.1in',
    },
  }}
>

  <div
    style={{
      transform: 'rotate(-90deg)',
      width: '2.3in',  // Set the width to the height of the box
      height: '100%',  // Set the height to 100% to fill the available space
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'left',
      textAlign: 'center',
      position: 'absolute',
      left: '22px',
      top: 0,
    }}
  >
    <div
  style={{
    position: "absolute",
    top: "0.1in",
    left: "-0.23in",
  }}
>
  {logoURL && (
    <img
      src={logoURL}
      alt=" "
      style={{ width: "38px", height: "38px" }}
    />
  )}
</div>
<div
  style={{
    width: '70%',
    fontSize: '15px',
    fontWeight: 'bold',
    color: 'hsl(0, 0.00%, 100.00%)',
    position: 'absolute',
    top: '0.16in',
    left: '0.2in',
    lineHeight: '1.4em',
    overflow: 'visible',  // ✅ Allow it to grow
    whiteSpace: 'normal', // ✅ Allow wrapping
    wordWrap: 'break-word', // Optional: breaks long words if needed
    textAlign: 'left' // Align text to the left
  }}
>
  {schoolData?.schoolName}
</div>
  </div>
 

  <div
  style={{
    transform: 'rotate(-90deg)',
    position: 'absolute',
    bottom: '0.6in',
    left: '2.2in',
    color: 'black',
    fontSize: '15px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center name and designation horizontally
    justifyContent: 'center',
    lineHeight: '1.3'
  }}
>
  {/* Centered Name */}
  <p style={{ margin: '1px 0', fontWeight: '600', color:'rgb(20, 31, 73)', fontSize:'17.5px' }}>
    <b>{teacher.Name}</b>
  </p>

  {/* Centered Designation */}
  <p style={{ margin: '1px 0', fontWeight: '500', color:'rgb(34, 46, 94)' , fontSize:'15.5px', marginBottom:'13px'}}>
    <b>{teacher.Designation}</b>
  </p>

  {/* Start from left */}
  <div style={{ alignSelf: 'flex-start', color:'rgb(37, 47, 88)' }}>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Mobile :' : 'मोबाइल :'} {teacher.Mobno}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Birth Date :' : 'जन्मतारीख :'} {teacher.DOB}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Date of Joining :' : 'सेवा रुजू तारीख :'} {teacher.DOJ}</b>
    </p>
    <p style={{ margin: '3.5px 0' }}>
      <b>{language === 'English' ? 'Qualification :' : 'शैक्षणिक पात्रता :'} {teacher.Qualification}</b>
    </p>

    {/* Conditionally render the Subject field */}
    {teacher.subject && (
      <p style={{ margin: '3.5px 0' }}>
        <b>{language === 'English' ? 'Subject :' : 'विषय :'} {teacher.subject}</b>
      </p>
    )}
  </div>
</div>


  <div style={{ transform: 'rotate(-90deg)', }} >

    <p style={{ position: 'absolute', bottom: '-2.39in', left: '-0.45in', fontSize: '12px', color:'rgb(0, 0, 0)' }}> {language === "English" ? "PRINCIPAL " : "प्राचार्य "}</p>
 
  </div>



  <div style={{ position: 'absolute', top: '0.72in', right: '2.58in' }}>
    {teacher.Image && ( 
      <img
        src={teacher.Image}
        alt="Teacher Photo"
        style={{
          width: '1.38in',
          height: '1.4in',
          border: '3px solid rgb(29, 39, 78)',
          borderRadius:'50%', // Adds a light gray border with a thickness of 2px
          transform: 'rotate(-90deg)', // Rotates the image 90 degrees
        }}
      />
    )}
  </div>
</div>
)}
      </div>
    );
  };


  const renderPages = () => {
    if (!formData || !selectedTeachers) return null;

    const pages = [];
    for (let i = 0; i < selectedTeachers.length; i += 8) {
      const pageTeachers = selectedTeachers.slice(i, i + 8);
      pages.push(
        <div
          key={i}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gridTemplateRows: 'repeat(4, auto)',
            gridGap: '10px',
            width: '8.27in', // A4 width
            height: '11.69in', // A4 height
            padding: '0.5in', // Add padding for margins
            fontFamily: "'NotoSansDevanagari', sans-serif",
            border: 'none',
            boxSizing: 'border-box',
            margin: '10px 10px', // Center the page content
            marginBottom: '0.7in', // Add margin at the bottom for page break
            pageBreakBefore: 'always', // Ensure a page break before each page
            pageBreakAfter: 'always', // Ensure a page break after each page
            pageBreakInside: 'avoid', // Prevent breaking content inside the page
          }}
          className="page-container" // Add a class for print-specific styling
        >
          {pageTeachers.map((teacher) => renderIDCard(teacher))}
        </div>
      );
    }

    return pages;
  };


  const printCertificate = async () => {
    const printContent = document.getElementById("print-content");
    const originalContent = document.body.innerHTML;

    // Apply CSS styles directly to the print content for positioning
    printContent.style.padding = "0"; // Reset padding for print
    printContent.style.margin = "0"; // Reset margin for print

    // Ensure proper page breaks for printing
    const printStyle = document.createElement("style");
    printStyle.innerHTML = `
      @media print {
        @page {
          size: A4; /* Set page size to A4 */
          margin: 0.27in; /* Set margins for A4 */
        }
        .main-content-of-page {
          display: block;
        }
        .page-container {
          width: 8.32in; /* A4 width */
          height: 11.74in; /* A4 height */
          page-break-after: always;
          page-break-inside: avoid;
        }
      }
    `;
    document.head.appendChild(printStyle);

    document.body.innerHTML = printContent.outerHTML; // Replace body with print content
    window.print(); // Print the current document
    document.body.innerHTML = originalContent; // Restore the original content
    window.location.reload();
  };


  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "5em",
        }}
      >
        <div id="print-content" className='main-content-of-page'>
          {loading ? <p>Loading...</p> : renderPages()}
        </div>


        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button style={{ width: '80px', height: '40px', marginLeft: '10px', padding: '0 8px', backgroundColor: 'gray', borderRadius: '5px' }}  onClick={() => {
    setDesign((prevDesign) => {
      if (prevDesign === 'default') return 'ID5';
      if (prevDesign === 'ID5') return 'new';
      if (prevDesign === 'new') return 'alternative';
      if (prevDesign === 'alternative') return 'new4';
      if (prevDesign === 'new4') return 'ID6';
      if (prevDesign === 'ID6') return 'ID7';
      if (prevDesign === 'ID7') return 'ID8';
      return 'default'; 
    });
  }}
          >
            Next <i className="fa-solid fa-circle-chevron-right"></i>
          </button></div>
        <br />
        <div >
          <button
            onClick={printCertificate}
            style={{ width: '80px', height: '40px', marginLeft: '10px', padding: '0 10px', borderRadius: '5px' }}
          >
            Print
          </button>
        </div>

      </div>
    </>
  );
}

export default TIdDoc;
